import * as RadixSwitch from '@radix-ui/react-switch';
import classNames from 'classnames';
import { forwardRef } from 'react';

import { Spinner } from '@air/primitive-spinner';

export type SwitchProps = RadixSwitch.SwitchProps & {
  isLoading?: boolean;
};

export const Switch = forwardRef<HTMLButtonElement, SwitchProps>(
  ({ className, disabled, isLoading, ...restOfProps }: SwitchProps, ref) => {
    return (
      <RadixSwitch.Root
        className={classNames(
          'group block h-4 w-6 shrink-0 rounded-full ads:bg-ads-gray-6 bg-gray-6 radix-state-checked:ads:bg-primary radix-state-checked:bg-blue-9 p-0.5 outline-none transition-colors',
          'active:ads:bg-ads-gray-8 active:bg-gray-8 active:radix-state-checked:ads:bg-hover-primary active:radix-state-checked:bg-blue-10',
          'hover:ads:bg-ads-gray-8 hover:bg-gray-8 hover:radix-state-checked:ads:bg-hover-primary hover:radix-state-checked:bg-blue-10',
          'focus-visible:ads:ring-focus focus-visible:ring-2 focus-visible:ring-blue-9 focus-visible:ring-offset-1',
          'disabled:ads:bg-input disabled:bg-gray-5 disabled:radix-state-checked:ads:bg-primary-subtle disabled:radix-state-checked:bg-blue-3',
          className,
        )}
        data-testid="SWITCH"
        disabled={disabled || isLoading}
        ref={ref}
        {...restOfProps}
      >
        <RadixSwitch.Thumb className="flex size-3 radix-state-checked:translate-x-2 items-center justify-center rounded-full bg-white transition-transform">
          {isLoading && (
            <Spinner className="size-2 ads:text-ads-gray-6 text-gray-6 ads:group-radix-state-checked:text-icon-primary group-radix-state-checked:text-blue-9" />
          )}
        </RadixSwitch.Thumb>
      </RadixSwitch.Root>
    );
  },
);

Switch.displayName = 'Switch';
